var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"items":_vm.items,"title":_vm.title}}),_c('div',{staticClass:"container mt-3"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"m-3",style:({
          backgroundSize: '125px',
          backgroundImage:
            'url(' + require("@/assets/logo-shanrise-opc.png") + ')',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top right',
        })},[_c('b-card-title',{staticClass:"text-center"}),_c('b-card-body',{staticClass:"text-center"},[_c('h3',[_vm._v("Selamat Nilai Kamu Sedang Dalam Proses, Info Lebih Lanjut Silahkan Hubungi Pihak Terkait.")])])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }